import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-b3a6fbfe"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "node-container"
}
const _hoisted_2 = {
  key: 1,
  class: "any"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-spin pi-spinner" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 2,
  class: "any"
}
const _hoisted_6 = { class: "search-cont" }

import { ref, onMounted, watch } from "vue";

import InputText from "primevue/inputtext";
import TreeSelect from "primevue/treeselect";
import IconField from "primevue/iconfield";
import InputIcon from "primevue/inputicon";

import { useCategoriesStore } from "@/store/catalog_data/categories";


export default /*#__PURE__*/_defineComponent({
  __name: 'CategoryTreeInput',
  props: ["modelValue", "isSegmentSetted"],
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;
const emit = __emit;
const categoryStore = useCategoriesStore();

const filter = ref("");
const isLoading = ref(false);
const debounceTimeout = ref(null as number | null);
const selectedNodes = ref([] as any[]);

const sendItemRequest = () => {
  isLoading.value = true;
  categoryStore.getItems(filter.value).then(() => {
    isLoading.value = false;
  });
};

watch(
  () => filter.value,
  () => {
    if (debounceTimeout.value) clearTimeout(debounceTimeout.value);
    debounceTimeout.value = setTimeout(sendItemRequest, 1000);
  }
);

onMounted(() => {
  loadCategories();
});

const loadChoosenValues = (dataToMatch: number[]) => {
  isLoading.value = true;
  categoryStore.getMapItems().then(() => {
    categoryStore.getItems().then(() => {
      if (Array.isArray(dataToMatch))
        categoryStore.getChoosenItems(dataToMatch).then(() => {
          emit("update:modelValue", createMap(dataToMatch));
          isLoading.value = false;
        });
    });
  });
};

const loadCategories = () => {
  isLoading.value = true;
  categoryStore.getMapItems().then(() => {
    categoryStore.getItems().then(() => {
      isLoading.value = false;
    });
  });
};

const getNodes = () => {
  selectedNodes.value = getSelectedNodes();
  return selectedNodes;
};

const beforeShow = () => {
  const element = document.querySelectorAll(
    ".p-tree-container .p-treenode[aria-selected='true'][aria-expanded='true']"
  );
  element.forEach((element) => {
    element.classList.add("scoped");
    element.addEventListener("click", () => {
      if (element && element.classList.contains("scoped")) {
        element.querySelectorAll(".p-treenode-content button")[0].click();
        element.classList.remove("scoped");
      }
    });
  });
};

const nodeExpand = (event: any) => {
  if (
    event.children &&
    event.children.length == 1 &&
    event.children[0].data == 0
  ) {
    isLoading.value = true;
    categoryStore.getItems("", event.data).then((category: any) => {
      isLoading.value = false;
      const m = { ...props.modelValue };

      const expanded = document.querySelectorAll(
        ".p-treenode[aria-expanded='true']"
      );

      const expandedClasses: Element[] = [];

      expanded.forEach((e) =>
        expandedClasses.push(e.childNodes[0].classList[1])
      );

      // костыль для сворачивания leaf
      if (category.key in m && m[category.key].checked) {
        category.children.forEach((element: any) => {
          m[element.key] = {
            checked: true,
            partialChecked: false,
          };
        });

        emit("update:modelValue", m);

        setTimeout(() => {
          const children = document.querySelectorAll(
            ".p-treenode[aria-expanded='true']"
          );
          children?.forEach((element: Element) => {
            const zasr = element.querySelectorAll(
              ".p-treenode-children .p-treenode"
            );

            const catClass = element.childNodes[0].classList[1];

            if (
              (zasr.length == 1 && zasr[0].ariaLabel == "Другие варианты") ||
              !expandedClasses.includes(catClass)
            ) {
              element.querySelectorAll(".p-treenode-content button")[0].click();
            }
          });
        }, 100);
      }
    });
  }
};

// get only selected for input
function getSelectedNodes() {
  const value = props.modelValue;
  const newNodes: any[] = [];
  Object.keys(value).forEach((key: string) => {
    const parentKeyParts = key.split("-");
    const child = parentKeyParts.pop();

    const parentKey = parentKeyParts.join("-");
    if (
      !(value[parentKey] && value[parentKey].checked) &&
      value[key].checked &&
      child != "0" &&
      child
    ) {
      newNodes.push({
        key: key,
        label: categoryStore.categoriesMap.get(parseInt(child))?.name,
      });
    }
  });

  return newNodes;
}

//map category to v-model
function createMap(dataToMatch: any[]) {
  const resultMap: any = {};

  function checkAndAddToMap(item: any, isParentMatched: boolean) {
    const isMatched = dataToMatch.includes(item.data);
    const hasChildren = Boolean(item.children && item.children.length > 0);
    let isChildMatched = false;

    if (hasChildren) {
      item.children.forEach((child: any) => {
        isChildMatched =
          checkAndAddToMap(child, isMatched || isParentMatched) ||
          isChildMatched;
      });
    }

    const partialMatched =
      !isMatched && hasChildren && !isParentMatched && isChildMatched;

    if (
      !item.key.endsWith("-0") &&
      (isMatched || isParentMatched || hasChildren)
    ) {
      const newItem = {
        checked: isMatched || isParentMatched,
        partialChecked: partialMatched,
      };
      if (newItem.checked || newItem.partialChecked) {
        resultMap[item.key] = newItem;
      }
    }

    return isMatched || partialMatched;
  }

  categoryStore.allCategories.forEach((state: any) => {
    if (dataToMatch) checkAndAddToMap(state, false);
  });

  return resultMap;
}

__expose({
  loadChoosenValues,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TreeSelect), {
    modelValue: props.modelValue,
    options: 
      __props.isSegmentSetted ? _unref(categoryStore).allCategories : _unref(categoryStore).categories
    ,
    class: "categories",
    selectionMode: "checkbox",
    placeholder: "Любая категория",
    panelClass: [__props.isSegmentSetted ? 'hidden' : ''],
    onNodeExpand: nodeExpand,
    onShow: beforeShow,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = 
      ($event) => {
        emit('update:modelValue', $event);
      }
    )
  }, _createSlots({
    value: _withCtx(() => [
      (getNodes().value.length > 0 && !Array.isArray(props.modelValue))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedNodes.value, (node) => {
              return (_openBlock(), _createElementBlock("div", {
                key: node.key,
                class: "node"
              }, _toDisplayString(node.label), 1))
            }), 128))
          ]))
        : (
          (Array.isArray(props.modelValue) && props.modelValue.length > 0) ||
          isLoading.value
        )
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, "Любая категория"))
    ]),
    _: 2
  }, [
    (!__props.isSegmentSetted)
      ? {
          name: "header",
          fn: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_unref(IconField), { iconPosition: "left" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(InputIcon), {
                    class: _normalizeClass([isLoading.value ? 'pi pi-spin pi-spinner' : 'pi pi-search'])
                  }, null, 8, ["class"]),
                  _createVNode(_unref(InputText), {
                    modelValue: filter.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filter).value = $event)),
                    placeholder: "Поиск по категориям"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ])
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["modelValue", "options", "panelClass"]))
}
}

})